module.exports = __webpack_public_path__ + "static/media/copy.9b810120.svg";